import { render, staticRenderFns } from "./BandejaOrdinario.vue?vue&type=template&id=3d73b994"
import script from "./BandejaOrdinario.vue?vue&type=script&lang=js"
export * from "./BandejaOrdinario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports